import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import useLocalStorage from 'use-local-storage'
import Login from './components/Login'
import Main from './components/Main'
import List from './components/List'
import Share from './components/Share'
import Profile from './components/Profile'
import Friends from './components/Friends'
import Settings from './components/Settings'
import ConnectivityMsg from './components/ConnectivityMsg'
import Alerts from './components/Alerts'
import GlobalState from './context/GlobalState'
import './App.css'

function App() {
  const [theme, setTheme] = useLocalStorage('theme', 'light' ? 'dark' : 'light');
  document.body.setAttribute('data-theme', theme);

  return (
    <div className="App" data-theme={theme}>
      <GlobalState>
        <ConnectivityMsg />
        <Alerts />
        <Router basename="/listapp">
          <Routes>
            <Route path='/login' element={ <Login /> } />
            <Route path='/' element={ <Main /> } />
            <Route path='/list' element={ <List /> } >
              <Route path=':listID' element={ <List /> } />
            </Route>
            <Route path='/share/:listID' element={ <Share /> } />
            <Route path='/profile' element={ <Profile /> } />
            <Route path='/friends' element={ <Friends /> } />
            <Route path='/settings' element={ <Settings /> } />
          </Routes>
        </Router>
      </GlobalState>
    </div>
  )
}

export default App